/**
 * Copyright (c) 2021
 *
 * Event componenent of the Javacript SDK for Gift Card Pro. To be included and
 * made available in the storefront javascript file
 *
 * @summary short description for the file
 * @author Zac Fair <zac@gist-apps.com>
 *
 * Created at     : 2021-10-22 3:04:00
 * Last modified  : 2021-10-22 3:04:00
 */

const gcpEvents = [
  'gcp-page-loaded',
  'gcp-item-added',
  'gcp-form-loaded',
  'gcp-form-changed',
  'gcp-field-changed'
];

/**
 * Dispatch a Gift Card Pro SDK event. Valid event names are defined above, and are outlined at
 * https://docs.easy-accounts.com/article/easyaccounts-javascript-sdk/
 * @param {String} eventName
 */
export function dispatchSdKEvent(eventName: string, detail: any = null, timeout = 0) {

  try {

    if (!gcpEvents.includes(eventName)) {
      console.warn("Attempting to register an invalid event name");
    }

    const sdkEvent = (() => {

      if (detail !== null) {
        return new CustomEvent(eventName, detail);
      }
      
      return new Event(eventName);

    })();

    setTimeout(function() {
      document.dispatchEvent(sdkEvent)
    }, timeout);

  }
  catch(e) {
    console.warn("SDK Error: ", e);
  }


}
